/** @format */

const template = `
<div class="row">
  <div class="col-12">
    <span class="guidance" data-cy="search-result-none" ng-if="$ctrl.totalCount === undefined">&nbsp;</span>

    <span class="guidance" data-cy="search-result-zero" ng-if="$ctrl.totalCount == 0" translate="SEARCH_RESULTS.ZERO_RESULTS"></span>

    <span class="guidance" ng-if="$ctrl.totalCount == 1 && $ctrl.count == 1" translate="SEARCH_RESULTS.ONE_RESULT"></span>

    <span class="guidance" ng-if="$ctrl.totalCount > 1 && $ctrl.totalCount == $ctrl.count">
      <span translate="SEARCH_RESULTS.ALL_RESULTS_SHOWN" translate-values="{count: $ctrl.count}"></span>

      <a
        href
        ng-if="$ctrl.totalCount > $ctrl.pageSize"
        ng-click="$ctrl.toggleShowMaxResults()"
        translate="SEARCH_RESULTS.SHOW_LESS_RESULTS"></a>
    </span>

    <span class="guidance" ng-if="$ctrl.totalCount > 0 && $ctrl.totalCount > $ctrl.count && $ctrl.count > 0">
      <span translate="SEARCH_RESULTS.ALL_RESULTS_NOT_SHOWN" translate-values="{totalCount: $ctrl.totalCount, count: $ctrl.count}"></span>

      <span ng-if="$ctrl.showMaxResults" translate="SEARCH_RESULTS.TOO_MANY_RESULTS"></span>

      <a
        href
        ng-click="$ctrl.toggleShowMaxResults()"
        translate="{{ $ctrl.showMaxResults ? 'SEARCH_RESULTS.SHOW_LESS_RESULTS' : 'SEARCH_RESULTS.SHOW_MORE_RESULTS' }}">
      </a>
    </span>

    <span
      ng-if="$ctrl.searchParams.searchString.value.length > 255"
      translate="INPUT_ERRORS.SEARCH_QUERY_TEXT_TOO_LONG"
      class="guidance"></span>

    <p ng-if="$ctrl.truncated" class="results-no-show guidance" translate>SEARCH_RESULTS.RESULTS_TRUNCATED</p>
  </div>
</div>
`;
export default template;
